module.exports = __webpack_public_path__ + "static/media/Group.146319b4.png";